function LogOutIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      fill='none'
      viewBox='0 0 24 24'
      style={{ marginRight: '3px' }}
    >
      <path
        fill='#5A6675'
        d='M8 12.75h7V18c0 2-1 3-3 3H6c-2 0-3-1-3-3V6c0-2 1-3 3-3h6c2 0 3 1 3 3v5.25H8a.75.75 0 000 1.5zm13.692-1.037a.749.749 0 00-.162-.244l-3-3a.75.75 0 10-1.061 1.061l1.72 1.72H15v1.5h4.189l-1.72 1.72a.75.75 0 001.06 1.061l3-3a.747.747 0 00.163-.818z'
      />
    </svg>
  );
}

export default LogOutIcon;
